// extracted by mini-css-extract-plugin
export var progressBar = "_nt-0";
export var progressBarInner = "_nt-1";